/* ProductTile is a custom element for Donna Karan */
/* (Not part of original Maker theme) */
class ProductTile extends HTMLElement {
  constructor () {
    super()
  }
  connectedCallback () {
    window.masterSkus = window.masterSkus || [];
    this.masterSku = this.getAttribute('data-master-sku');
    this.tileObserver = null;
    this.watchViewport();
    //this.clickEventListener();
  }
  disconnectedCallback () {
    if (this.tileObserver != null) {
      this.tileObserver.unobserve(this);
      this.tileObserver = null;
    }
  }
  static get observedAttributes () {
    return ['data-viewport-observed']
  }
  attributeChangedCallback (name, oldValue, newValue) {
    if (name == 'data-viewport-observed' && oldValue == 'false' && newValue == 'true') {
      if (this.masterSku) {
        this.loadByMasterSku();
      } else {
        console.log('~~~~~ NO MASTER SKU')
      }
      this.tileObserver.unobserve(this);
      this.tileObserver = null;
    }
  }
  /*clickEventListener() {
    var plinks = this.querySelectorAll('.product-tile--link');
    for (var i = 0; i < plinks.length; i++) {
      var plink = plinks[i];
      plink.on('click.ProductTile', (e) => {
        e.preventDefault();
        console.log('click.ProductTile', e);
        return false;
      })
    }
  }*/
  watchViewport() {
    var intersectOpt = { root: null, threshold: 0.4 };
    var handleIntersect = function(entries, observer) {
        var observedElements = [];
        var intersectCount = 0;
        entries.forEach(function(entry) {
            var observed = entry.target.getAttribute('data-viewport-observed');
            if (entry.isIntersecting) {
                if (observed == 'true'){
                    // skip
                } else {
                    entry.target.setAttribute('data-viewport-observed', 'true');
                    intersectCount++;
                    observedElements.push(entry.target);
                }
            }
        });
        if (intersectCount > 0) {                       
            window.trigger('theme:producttile:viewed', observedElements);
        }
    }
    this.tileObserver = new IntersectionObserver(handleIntersect, intersectOpt);
    this.tileObserver.observe(this);
  }
  loadByMasterSku() {
    if (window.masterSkus.indexOf(this.masterSku) == -1) {
      window.masterSkus.push(this.masterSku);
      
      var fetchUrl = theme.urls.all_products_collection.concat("/MasterSku:".concat(this.masterSku), "?view=data");
      fetch(fetchUrl)
        .then((response) => response.json())
        .then((data) => this.handleMasterSkuResponse(data));
    }
  }
  handleMasterSkuResponse(data) {
    window.trigger(`theme:producttile:${this.masterSku}:variantsLoaded`, {
      products: data.products
    });
  }
}
const productTileEl = customElements.get('product-tile-root')
productTileEl || customElements.define('product-tile-root', ProductTile)
